import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BannerService } from 'src/app/services/banner-service/banner.service';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';

@Component({
    selector: 'app-mm-right-column',
    templateUrl: './mm-right-column.component.html',
    styleUrls: ['./mm-right-column.component.scss'],
})
export class MmRightColumnComponent implements OnInit {
    public segmentacao: any = {};
    public bannersVeiculacao: any = [];

    constructor(
        public modelLocator: ModelLocatorService,
        private bannerService: BannerService,
        private router: Router
    ) {
    }

    async ngOnInit() {

        this.segmentacao = {
            slot: 'direita',
            cpf: this.modelLocator.dadosLogin.cpf,
            owner: this.modelLocator.dadosLogin.idowner,
            perfil: this.modelLocator.dadosLogin.idperfil
        };

        if (this.modelLocator.dadosLogin.lojas) {
            this.segmentacao.lojas = this.modelLocator.dadosLogin.lojas;
        }

        await this.listaBanners();

    }

    async listaBanners() {
        try {
            const resultBanners = await this.bannerService.getAllBanners(this.segmentacao);
            if (resultBanners && resultBanners['status'] === 200) {
                this.bannersVeiculacao = resultBanners['result'];
            }
        } catch (err) {
            console.error('Erro ao listar banners:', err);
        }
    };

    touchGoToRoute(rota: string) {
        if (rota.lastIndexOf('http') >= 0) {
            window.open(rota, '_blank', 'location=yes');
        } else {
            this.router.navigate([rota]);
        }
    };

}
